import styled from 'styled-components'

export const Wrapper = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    background: #ffffff;
    padding: 12px;
`

export const InnerWrapper = styled.div`
    position: relative;
`

export const OhIcon = styled.img`
    position: absolute;
    top: 0;
    left: 0;
`

export const CloseIcon = styled.img`
    position: absolute;
    top: 4px;
    right: 0;
`

export const TextElement = styled.div`
    padding-left: 47px;
    color: #228bec;
    font-size: 16px;
    line-height: 32px;
    font-weight: 600;
`
